import React from "react";

// import styled from "styled-components";
// import { LoginCarouselData } from "../../../utils";
// import FallbackImage from "../../Common/ImageWrapper";
// import SwiperComp from "../../Common/SwiperComp";

import ResetPasswordForm from "./ResetPasswordForm";
import { useState } from "react";
import CheckEmail from "./CheckEmail";
import Failed from "./Failed";

const backgroundImageStyleLeft = {
  backgroundImage: `url("../Images/Login/sign-up-left.png")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

const backgroundImageStyleRight = {
  backgroundImage: `url("../Images/Login/sign-up-right.png")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export default function ResetPasswordComp() {
  const [pageName, setPageName] = useState("ResetPasswordForm");
  const pages = [
    {
      name: "ResetPasswordForm",
      component: <ResetPasswordForm setPageName={setPageName} />,
    },
    {
      name: "Success",
      component: <CheckEmail />,
    },
    {
      name: "Failed",
      component: <Failed setPageName={setPageName} />,
    },
  ];
  return (
    <div className="Login">
      {/* <NavbarPage /> */}

      <div className="">
        <div className="flex flex-col lg:flex-row lg:gap-0">
          {/* <div className="col-lg-7 bg-white sideA d-block">
            <SwiperComp Data={LoginCarouselData} Page={PageSide} />
          </div> */}
          <div
            className="lg:w-1/2 p-10 lg:p-20 min-h-screen flex flex-col items-center justify-center"
            style={backgroundImageStyleLeft}
          >
            {pages?.find((item) => item?.name === pageName)?.component}
          </div>
          <div
            className="lg:w-1/2 lg:flex lg:flex-col items-center justify-center h-screen lg:h-auto hidden"
            style={backgroundImageStyleRight}
          >
            <div className="flex flex-col items-center bg-white p-10 rounded-3xl">
              <img
                src="../Images/Login/sign-up-image.png"
                alt="profile"
                className="w-[100px] h-[100px]"
              />
              <p className="font-[700] text-[32px]">
                Ifesowapo Cooperative, LTC
              </p>
              <p className="text-[#858585] text-lg">
                6&7, Alaka Express, Gbagada, Surulere, Lagos
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// const PageSide = (item) => {
//   return (
//     <PageSideStyle className="position-relative bg-white text-black h-100">
//       <div className="d-none d-md-flex" style={{ height: "40vh" }}>
//         <FallbackImage src="/Login/top.png" width={246} height={246} />
//       </div>
//       <div className="mb-md-5 pb-5 container col-lg-10">
//         <h1 className="text-center fw-bolder h10 col-md-11 mb-md-4 ">
//           {item?.title}
//         </h1>
//         <p className="text-start d-none d-lg-block lh-lg">{item?.desc}</p>
//         <p className="text-center  d-md-none">
//           Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur
//           nunc, erat auctor commodo eu nu
//         </p>
//       </div>
//       <div className="py-md-5 my-md-5"></div>
//       <div className="d-none d-md-flex align-items-end position-absolute bottom-0 w-100">
//         <FallbackImage src="/Login/bottom.svg" width={"100%"} />
//       </div>
//       <div className="d-flex justify-content-center"></div>
//     </PageSideStyle>
//   );
// };

// const PageSideStyle = styled.div`
//   z-index: 3;
//   height: 100% !important;
// `;
